import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';

export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'riskScore',
    label: 'Risk Score',
    sortable: false,
  },
  {
    name: 'paymentType',
    label: 'Payment Type',
    sortable: false,
  },
  {
    name: 'transactionTypeId',
    label: 'Transaction Type',
    sortable: false,
  },
  {
    name: 'createdAt',
    label: 'Created date',
    hidden: false,
  },
];

export const columnsLabels = {
  transactionTypeId: 'Transaction Type',
  paymentType: 'Payment Type',
};

export const defaultSorter = {};

export const schema = {
  transactionTypeId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  paymentType: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const filtersSchema = [
  {
    name: 'transactionTypeId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Search by type...',
  },
  {
    name: 'paymentType',
    type: FilterType.RADIO,
    withClearButton: true,
    fields: [
      // {
      //   name: 'paymentType',
      //   title: 'Faster Payment',
      //   value: 'FASTER_PAYMENT',
      // },
      // {
      //   name: 'paymentType',
      //   title: 'Bacs',
      //   value: 'BACS',
      // },
      // {
      //   name: 'paymentType',
      //   title: 'Sepa Sct Inst',
      //   value: 'SEPA_SCT_INST',
      // },
      // {
      //   name: 'paymentType',
      //   title: 'Sepa Sct',
      //   value: 'SEPA_SCT',
      // },
      // {
      //   name: 'paymentType',
      //   title: 'Target 2',
      //   value: 'TARGET_2',
      // },
      // {
      //   name: 'paymentType',
      //   title: 'Swift',
      //   value: 'SWIFT',
      // },
      // {
      //   name: 'paymentType',
      //   title: 'Crypto Asset Payment',
      //   value: 'CRYPTO_ASSET_PAYMENT',
      // },
      // {
      //   name: 'paymentType',
      //   title: 'Cash Over Counter',
      //   value: 'CASH_OVER_COUNTER',
      // },
      // {
      //   name: 'paymentType',
      //   title: 'Fedwire',
      //   value: 'FEDWIRE',
      // },
    ],
  },
];
